/* @generated from adl module ferovinum.app.ledgercorrection */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as ferovinum_app_db from './db';

export interface LedgerCorrectionReq {
  /**
   * A UUID the caller supplies and keeps, so a retry under it is recognised.
   */
  correctionId: string;
  organisationId: ferovinum_app_db.OrganisationId;
  reason: string;
  ticketRef: string;
  /**
   * Defaults on: an apply is the same payload with this off, validated afresh.
   */
  dryRun: boolean;
  operations: LedgerCorrectionOperation[];
}

export function makeLedgerCorrectionReq(
  input: {
    correctionId: string,
    organisationId: ferovinum_app_db.OrganisationId,
    reason: string,
    ticketRef: string,
    dryRun?: boolean,
    operations: LedgerCorrectionOperation[],
  }
): LedgerCorrectionReq {
  return {
    correctionId: input.correctionId,
    organisationId: input.organisationId,
    reason: input.reason,
    ticketRef: input.ticketRef,
    dryRun: input.dryRun === undefined ? true : input.dryRun,
    operations: input.operations,
  };
}

const LedgerCorrectionReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"A UUID the caller supplies and keeps, so a retry under it is recognised.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"correctionId","default":{"kind":"nothing"},"name":"correctionId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"reason","default":{"kind":"nothing"},"name":"reason","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ticketRef","default":{"kind":"nothing"},"name":"ticketRef","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Defaults on: an apply is the same payload with this off, validated afresh.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"dryRun","default":{"kind":"just","value":true},"name":"dryRun","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"operations","default":{"kind":"nothing"},"name":"operations","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionOperation"}},"parameters":[]}]}}]}},"name":"LedgerCorrectionReq","version":{"kind":"nothing"}}};

export const snLedgerCorrectionReq: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionReq"};

export function texprLedgerCorrectionReq(): ADL.ATypeExpr<LedgerCorrectionReq> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionReq}, parameters : []}};
}

export interface LedgerCorrectionOperation_Transfer {
  kind: 'transfer';
  value: LedgerCorrectionTransfer;
}
export interface LedgerCorrectionOperation_Invert {
  kind: 'invert';
  value: LedgerCorrectionInvert;
}

export type LedgerCorrectionOperation = LedgerCorrectionOperation_Transfer | LedgerCorrectionOperation_Invert;

export interface LedgerCorrectionOperationOpts {
  transfer: LedgerCorrectionTransfer;
  invert: LedgerCorrectionInvert;
}

export function makeLedgerCorrectionOperation<K extends keyof LedgerCorrectionOperationOpts>(kind: K, value: LedgerCorrectionOperationOpts[K]) { return {kind, value}; }

const LedgerCorrectionOperation_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"transfer","default":{"kind":"nothing"},"name":"transfer","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionTransfer"}},"parameters":[]}},{"annotations":[],"serializedName":"invert","default":{"kind":"nothing"},"name":"invert","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionInvert"}},"parameters":[]}}]}},"name":"LedgerCorrectionOperation","version":{"kind":"nothing"}}};

export const snLedgerCorrectionOperation: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionOperation"};

export function texprLedgerCorrectionOperation(): ADL.ATypeExpr<LedgerCorrectionOperation> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionOperation}, parameters : []}};
}

export interface LedgerCorrectionTransfer {
  from: LedgerCorrectionPositionAddress;
  to: LedgerCorrectionPositionAddress;
  /**
   * `cash/<currency>` or `stock/<productId>`.
   */
  asset: string;
  /**
   * Major units, greater than zero.
   */
  amount: common.BigDecimal;
  /**
   * Empty is a positions-only move.
   */
  postings: LedgerCorrectionPosting[];
  processId: (number|null);
  /**
   * A journal event code; null records `ledger-correction.transfer`.
   */
  event: (string|null);
}

export function makeLedgerCorrectionTransfer(
  input: {
    from: LedgerCorrectionPositionAddress,
    to: LedgerCorrectionPositionAddress,
    asset: string,
    amount: common.BigDecimal,
    postings?: LedgerCorrectionPosting[],
    processId?: (number|null),
    event?: (string|null),
  }
): LedgerCorrectionTransfer {
  return {
    from: input.from,
    to: input.to,
    asset: input.asset,
    amount: input.amount,
    postings: input.postings === undefined ? [] : input.postings,
    processId: input.processId === undefined ? null : input.processId,
    event: input.event === undefined ? null : input.event,
  };
}

const LedgerCorrectionTransfer_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"from","default":{"kind":"nothing"},"name":"from","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionPositionAddress"}},"parameters":[]}},{"annotations":[],"serializedName":"to","default":{"kind":"nothing"},"name":"to","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionPositionAddress"}},"parameters":[]}},{"annotations":[{"value":"`cash/<currency>` or `stock/<productId>`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"asset","default":{"kind":"nothing"},"name":"asset","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Major units, greater than zero.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Empty is a positions-only move.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"postings","default":{"kind":"just","value":[]},"name":"postings","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionPosting"}},"parameters":[]}]}},{"annotations":[],"serializedName":"processId","default":{"kind":"just","value":null},"name":"processId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}]}},{"annotations":[{"value":"A journal event code; null records `ledger-correction.transfer`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"event","default":{"kind":"just","value":null},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"LedgerCorrectionTransfer","version":{"kind":"nothing"}}};

export const snLedgerCorrectionTransfer: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionTransfer"};

export function texprLedgerCorrectionTransfer(): ADL.ATypeExpr<LedgerCorrectionTransfer> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionTransfer}, parameters : []}};
}

export interface LedgerCorrectionInvert {
  journalRefs: string[];
  /**
   * A journal event code; null records `ledger-correction.inverted`.
   */
  event: (string|null);
}

export function makeLedgerCorrectionInvert(
  input: {
    journalRefs: string[],
    event?: (string|null),
  }
): LedgerCorrectionInvert {
  return {
    journalRefs: input.journalRefs,
    event: input.event === undefined ? null : input.event,
  };
}

const LedgerCorrectionInvert_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"journalRefs","default":{"kind":"nothing"},"name":"journalRefs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"value":"A journal event code; null records `ledger-correction.inverted`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"event","default":{"kind":"just","value":null},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"LedgerCorrectionInvert","version":{"kind":"nothing"}}};

export const snLedgerCorrectionInvert: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionInvert"};

export function texprLedgerCorrectionInvert(): ADL.ATypeExpr<LedgerCorrectionInvert> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionInvert}, parameters : []}};
}

export interface LedgerCorrectionPositionAddress {
  name: string;
  /**
   * `Client`, `Fero`, `Supplier` or `Purchaser`.
   */
  entity: string;
  stream: (LedgerCorrectionStream|null);
  processId: (number|null);
}

export function makeLedgerCorrectionPositionAddress(
  input: {
    name: string,
    entity: string,
    stream?: (LedgerCorrectionStream|null),
    processId?: (number|null),
  }
): LedgerCorrectionPositionAddress {
  return {
    name: input.name,
    entity: input.entity,
    stream: input.stream === undefined ? null : input.stream,
    processId: input.processId === undefined ? null : input.processId,
  };
}

const LedgerCorrectionPositionAddress_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"`Client`, `Fero`, `Supplier` or `Purchaser`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"entity","default":{"kind":"nothing"},"name":"entity","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"stream","default":{"kind":"just","value":null},"name":"stream","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionStream"}},"parameters":[]}]}},{"annotations":[],"serializedName":"processId","default":{"kind":"just","value":null},"name":"processId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}]}}]}},"name":"LedgerCorrectionPositionAddress","version":{"kind":"nothing"}}};

export const snLedgerCorrectionPositionAddress: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionPositionAddress"};

export function texprLedgerCorrectionPositionAddress(): ADL.ATypeExpr<LedgerCorrectionPositionAddress> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionPositionAddress}, parameters : []}};
}

export interface LedgerCorrectionStream {
  /**
   * `ContractLeg`, `SaleOrder` or `CapexAllocation`.
   */
  kind: string;
  id: string;
}

export function makeLedgerCorrectionStream(
  input: {
    kind: string,
    id: string,
  }
): LedgerCorrectionStream {
  return {
    kind: input.kind,
    id: input.id,
  };
}

const LedgerCorrectionStream_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"`ContractLeg`, `SaleOrder` or `CapexAllocation`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"LedgerCorrectionStream","version":{"kind":"nothing"}}};

export const snLedgerCorrectionStream: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionStream"};

export function texprLedgerCorrectionStream(): ADL.ATypeExpr<LedgerCorrectionStream> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionStream}, parameters : []}};
}

/**
 * `FeroAccount` names.
 */
export interface LedgerCorrectionPosting {
  debit: string;
  credit: string;
}

export function makeLedgerCorrectionPosting(
  input: {
    debit: string,
    credit: string,
  }
): LedgerCorrectionPosting {
  return {
    debit: input.debit,
    credit: input.credit,
  };
}

const LedgerCorrectionPosting_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[{"value":"`FeroAccount` names.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"debit","default":{"kind":"nothing"},"name":"debit","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"credit","default":{"kind":"nothing"},"name":"credit","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"LedgerCorrectionPosting","version":{"kind":"nothing"}}};

export const snLedgerCorrectionPosting: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionPosting"};

export function texprLedgerCorrectionPosting(): ADL.ATypeExpr<LedgerCorrectionPosting> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionPosting}, parameters : []}};
}

/**
 * The same shape for a dry run, an apply and a retry of one.
 */
export interface LedgerCorrectionResp {
  correctionId: string;
  dryRun: boolean;
  committed: boolean;
  alreadyApplied: boolean;
  counts: LedgerCorrectionCounts;
  journals: LedgerCorrectionJournal[];
  positions: LedgerCorrectionPositionChange[];
  accounts: LedgerCorrectionAccountChange[];
}

export function makeLedgerCorrectionResp(
  input: {
    correctionId: string,
    dryRun: boolean,
    committed: boolean,
    alreadyApplied: boolean,
    counts: LedgerCorrectionCounts,
    journals: LedgerCorrectionJournal[],
    positions: LedgerCorrectionPositionChange[],
    accounts: LedgerCorrectionAccountChange[],
  }
): LedgerCorrectionResp {
  return {
    correctionId: input.correctionId,
    dryRun: input.dryRun,
    committed: input.committed,
    alreadyApplied: input.alreadyApplied,
    counts: input.counts,
    journals: input.journals,
    positions: input.positions,
    accounts: input.accounts,
  };
}

const LedgerCorrectionResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[{"value":"The same shape for a dry run, an apply and a retry of one.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"correctionId","default":{"kind":"nothing"},"name":"correctionId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"dryRun","default":{"kind":"nothing"},"name":"dryRun","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"committed","default":{"kind":"nothing"},"name":"committed","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"alreadyApplied","default":{"kind":"nothing"},"name":"alreadyApplied","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"counts","default":{"kind":"nothing"},"name":"counts","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionCounts"}},"parameters":[]}},{"annotations":[],"serializedName":"journals","default":{"kind":"nothing"},"name":"journals","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionJournal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"positions","default":{"kind":"nothing"},"name":"positions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionPositionChange"}},"parameters":[]}]}},{"annotations":[],"serializedName":"accounts","default":{"kind":"nothing"},"name":"accounts","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionAccountChange"}},"parameters":[]}]}}]}},"name":"LedgerCorrectionResp","version":{"kind":"nothing"}}};

export const snLedgerCorrectionResp: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionResp"};

export function texprLedgerCorrectionResp(): ADL.ATypeExpr<LedgerCorrectionResp> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionResp}, parameters : []}};
}

export interface LedgerCorrectionCounts {
  journals: number;
  journalLines: number;
  positionEntries: number;
  entries: number;
}

export function makeLedgerCorrectionCounts(
  input: {
    journals: number,
    journalLines: number,
    positionEntries: number,
    entries: number,
  }
): LedgerCorrectionCounts {
  return {
    journals: input.journals,
    journalLines: input.journalLines,
    positionEntries: input.positionEntries,
    entries: input.entries,
  };
}

const LedgerCorrectionCounts_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"journals","default":{"kind":"nothing"},"name":"journals","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"journalLines","default":{"kind":"nothing"},"name":"journalLines","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"positionEntries","default":{"kind":"nothing"},"name":"positionEntries","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"LedgerCorrectionCounts","version":{"kind":"nothing"}}};

export const snLedgerCorrectionCounts: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionCounts"};

export function texprLedgerCorrectionCounts(): ADL.ATypeExpr<LedgerCorrectionCounts> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionCounts}, parameters : []}};
}

export interface LedgerCorrectionJournal {
  ref: string;
  event: string;
  lines: LedgerCorrectionLine[];
}

export function makeLedgerCorrectionJournal(
  input: {
    ref: string,
    event: string,
    lines: LedgerCorrectionLine[],
  }
): LedgerCorrectionJournal {
  return {
    ref: input.ref,
    event: input.event,
    lines: input.lines,
  };
}

const LedgerCorrectionJournal_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ref","default":{"kind":"nothing"},"name":"ref","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"event","default":{"kind":"nothing"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lines","default":{"kind":"nothing"},"name":"lines","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionLine"}},"parameters":[]}]}}]}},"name":"LedgerCorrectionJournal","version":{"kind":"nothing"}}};

export const snLedgerCorrectionJournal: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionJournal"};

export function texprLedgerCorrectionJournal(): ADL.ATypeExpr<LedgerCorrectionJournal> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionJournal}, parameters : []}};
}

export interface LedgerCorrectionLine {
  from: LedgerCorrectionPositionKey;
  to: LedgerCorrectionPositionKey;
  amount: common.BigDecimal;
  entries: LedgerCorrectionEntry[];
}

export function makeLedgerCorrectionLine(
  input: {
    from: LedgerCorrectionPositionKey,
    to: LedgerCorrectionPositionKey,
    amount: common.BigDecimal,
    entries: LedgerCorrectionEntry[],
  }
): LedgerCorrectionLine {
  return {
    from: input.from,
    to: input.to,
    amount: input.amount,
    entries: input.entries,
  };
}

const LedgerCorrectionLine_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"from","default":{"kind":"nothing"},"name":"from","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionPositionKey"}},"parameters":[]}},{"annotations":[],"serializedName":"to","default":{"kind":"nothing"},"name":"to","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionPositionKey"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionEntry"}},"parameters":[]}]}}]}},"name":"LedgerCorrectionLine","version":{"kind":"nothing"}}};

export const snLedgerCorrectionLine: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionLine"};

export function texprLedgerCorrectionLine(): ADL.ATypeExpr<LedgerCorrectionLine> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionLine}, parameters : []}};
}

export interface LedgerCorrectionEntry {
  account: string;
  entity: string;
  /**
   * `DEBIT` or `CREDIT`.
   */
  side: string;
  amount: common.BigDecimal;
}

export function makeLedgerCorrectionEntry(
  input: {
    account: string,
    entity: string,
    side: string,
    amount: common.BigDecimal,
  }
): LedgerCorrectionEntry {
  return {
    account: input.account,
    entity: input.entity,
    side: input.side,
    amount: input.amount,
  };
}

const LedgerCorrectionEntry_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"account","default":{"kind":"nothing"},"name":"account","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"entity","default":{"kind":"nothing"},"name":"entity","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"`DEBIT` or `CREDIT`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"side","default":{"kind":"nothing"},"name":"side","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"LedgerCorrectionEntry","version":{"kind":"nothing"}}};

export const snLedgerCorrectionEntry: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionEntry"};

export function texprLedgerCorrectionEntry(): ADL.ATypeExpr<LedgerCorrectionEntry> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionEntry}, parameters : []}};
}

export interface LedgerCorrectionPositionKey {
  name: string;
  entity: string;
  asset: string;
  stream: (LedgerCorrectionStream|null);
  processId: (number|null);
}

export function makeLedgerCorrectionPositionKey(
  input: {
    name: string,
    entity: string,
    asset: string,
    stream?: (LedgerCorrectionStream|null),
    processId?: (number|null),
  }
): LedgerCorrectionPositionKey {
  return {
    name: input.name,
    entity: input.entity,
    asset: input.asset,
    stream: input.stream === undefined ? null : input.stream,
    processId: input.processId === undefined ? null : input.processId,
  };
}

const LedgerCorrectionPositionKey_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"entity","default":{"kind":"nothing"},"name":"entity","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"asset","default":{"kind":"nothing"},"name":"asset","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"stream","default":{"kind":"just","value":null},"name":"stream","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionStream"}},"parameters":[]}]}},{"annotations":[],"serializedName":"processId","default":{"kind":"just","value":null},"name":"processId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}]}}]}},"name":"LedgerCorrectionPositionKey","version":{"kind":"nothing"}}};

export const snLedgerCorrectionPositionKey: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionPositionKey"};

export function texprLedgerCorrectionPositionKey(): ADL.ATypeExpr<LedgerCorrectionPositionKey> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionPositionKey}, parameters : []}};
}

/**
 * Balances in the ledger's insert order, the order its own balance checks read them in.
 */
export interface LedgerCorrectionPositionChange {
  key: LedgerCorrectionPositionKey;
  before: common.BigDecimal;
  after: common.BigDecimal;
}

export function makeLedgerCorrectionPositionChange(
  input: {
    key: LedgerCorrectionPositionKey,
    before: common.BigDecimal,
    after: common.BigDecimal,
  }
): LedgerCorrectionPositionChange {
  return {
    key: input.key,
    before: input.before,
    after: input.after,
  };
}

const LedgerCorrectionPositionChange_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[{"value":"Balances in the ledger's insert order, the order its own balance checks read them in.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"key","default":{"kind":"nothing"},"name":"key","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionPositionKey"}},"parameters":[]}},{"annotations":[],"serializedName":"before","default":{"kind":"nothing"},"name":"before","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"after","default":{"kind":"nothing"},"name":"after","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"LedgerCorrectionPositionChange","version":{"kind":"nothing"}}};

export const snLedgerCorrectionPositionChange: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionPositionChange"};

export function texprLedgerCorrectionPositionChange(): ADL.ATypeExpr<LedgerCorrectionPositionChange> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionPositionChange}, parameters : []}};
}

/**
 * Debit minus credit, in the ledger's insert order.
 */
export interface LedgerCorrectionAccountChange {
  name: string;
  entity: string;
  before: common.BigDecimal;
  after: common.BigDecimal;
}

export function makeLedgerCorrectionAccountChange(
  input: {
    name: string,
    entity: string,
    before: common.BigDecimal,
    after: common.BigDecimal,
  }
): LedgerCorrectionAccountChange {
  return {
    name: input.name,
    entity: input.entity,
    before: input.before,
    after: input.after,
  };
}

const LedgerCorrectionAccountChange_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[{"value":"Debit minus credit, in the ledger's insert order.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"entity","default":{"kind":"nothing"},"name":"entity","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"before","default":{"kind":"nothing"},"name":"before","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"after","default":{"kind":"nothing"},"name":"after","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"LedgerCorrectionAccountChange","version":{"kind":"nothing"}}};

export const snLedgerCorrectionAccountChange: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionAccountChange"};

export function texprLedgerCorrectionAccountChange(): ADL.ATypeExpr<LedgerCorrectionAccountChange> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionAccountChange}, parameters : []}};
}

export interface LedgerCorrectionsReq {
  organisationId: ferovinum_app_db.OrganisationId;
}

export function makeLedgerCorrectionsReq(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
  }
): LedgerCorrectionsReq {
  return {
    organisationId: input.organisationId,
  };
}

const LedgerCorrectionsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}}]}},"name":"LedgerCorrectionsReq","version":{"kind":"nothing"}}};

export const snLedgerCorrectionsReq: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionsReq"};

export function texprLedgerCorrectionsReq(): ADL.ATypeExpr<LedgerCorrectionsReq> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionsReq}, parameters : []}};
}

export interface LedgerCorrectionGetReq {
  correctionId: string;
}

export function makeLedgerCorrectionGetReq(
  input: {
    correctionId: string,
  }
): LedgerCorrectionGetReq {
  return {
    correctionId: input.correctionId,
  };
}

const LedgerCorrectionGetReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"correctionId","default":{"kind":"nothing"},"name":"correctionId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"LedgerCorrectionGetReq","version":{"kind":"nothing"}}};

export const snLedgerCorrectionGetReq: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionGetReq"};

export function texprLedgerCorrectionGetReq(): ADL.ATypeExpr<LedgerCorrectionGetReq> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionGetReq}, parameters : []}};
}

/**
 * A committed correction's audit row.
 */
export interface LedgerCorrectionSummary {
  correctionId: string;
  organisationId: ferovinum_app_db.OrganisationId;
  actor: ferovinum_app_db.AppUserId;
  reason: string;
  ticketRef: string;
  /**
   * The instant its journals took effect: when it was applied.
   */
  effectiveAt: (common.Instant|null);
  createdAt: common.Instant;
  /**
   * In operation order.
   */
  journalIds: number[];
}

export function makeLedgerCorrectionSummary(
  input: {
    correctionId: string,
    organisationId: ferovinum_app_db.OrganisationId,
    actor: ferovinum_app_db.AppUserId,
    reason: string,
    ticketRef: string,
    effectiveAt: (common.Instant|null),
    createdAt: common.Instant,
    journalIds: number[],
  }
): LedgerCorrectionSummary {
  return {
    correctionId: input.correctionId,
    organisationId: input.organisationId,
    actor: input.actor,
    reason: input.reason,
    ticketRef: input.ticketRef,
    effectiveAt: input.effectiveAt,
    createdAt: input.createdAt,
    journalIds: input.journalIds,
  };
}

const LedgerCorrectionSummary_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[{"value":"A committed correction's audit row.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"correctionId","default":{"kind":"nothing"},"name":"correctionId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"actor","default":{"kind":"nothing"},"name":"actor","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"AppUserId"}},"parameters":[]}},{"annotations":[],"serializedName":"reason","default":{"kind":"nothing"},"name":"reason","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ticketRef","default":{"kind":"nothing"},"name":"ticketRef","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The instant its journals took effect: when it was applied.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"effectiveAt","default":{"kind":"nothing"},"name":"effectiveAt","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"value":"In operation order.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"journalIds","default":{"kind":"nothing"},"name":"journalIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}]}}]}},"name":"LedgerCorrectionSummary","version":{"kind":"nothing"}}};

export const snLedgerCorrectionSummary: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionSummary"};

export function texprLedgerCorrectionSummary(): ADL.ATypeExpr<LedgerCorrectionSummary> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionSummary}, parameters : []}};
}

export interface LedgerCorrectionDetail {
  correction: LedgerCorrectionSummary;
  /**
   * Read back from the journals the row lists: what a retry of the same payload returns.
   */
  result: LedgerCorrectionResp;
}

export function makeLedgerCorrectionDetail(
  input: {
    correction: LedgerCorrectionSummary,
    result: LedgerCorrectionResp,
  }
): LedgerCorrectionDetail {
  return {
    correction: input.correction,
    result: input.result,
  };
}

const LedgerCorrectionDetail_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.ledgercorrection","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"correction","default":{"kind":"nothing"},"name":"correction","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionSummary"}},"parameters":[]}},{"annotations":[{"value":"Read back from the journals the row lists: what a retry of the same payload returns.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"result","default":{"kind":"nothing"},"name":"result","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.ledgercorrection","name":"LedgerCorrectionResp"}},"parameters":[]}}]}},"name":"LedgerCorrectionDetail","version":{"kind":"nothing"}}};

export const snLedgerCorrectionDetail: ADL.ScopedName = {moduleName:"ferovinum.app.ledgercorrection", name:"LedgerCorrectionDetail"};

export function texprLedgerCorrectionDetail(): ADL.ATypeExpr<LedgerCorrectionDetail> {
  return {value : {typeRef : {kind: "reference", value : snLedgerCorrectionDetail}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.ledgercorrection.LedgerCorrectionReq" : LedgerCorrectionReq_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionOperation" : LedgerCorrectionOperation_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionTransfer" : LedgerCorrectionTransfer_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionInvert" : LedgerCorrectionInvert_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionPositionAddress" : LedgerCorrectionPositionAddress_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionStream" : LedgerCorrectionStream_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionPosting" : LedgerCorrectionPosting_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionResp" : LedgerCorrectionResp_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionCounts" : LedgerCorrectionCounts_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionJournal" : LedgerCorrectionJournal_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionLine" : LedgerCorrectionLine_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionEntry" : LedgerCorrectionEntry_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionPositionKey" : LedgerCorrectionPositionKey_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionPositionChange" : LedgerCorrectionPositionChange_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionAccountChange" : LedgerCorrectionAccountChange_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionsReq" : LedgerCorrectionsReq_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionGetReq" : LedgerCorrectionGetReq_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionSummary" : LedgerCorrectionSummary_AST,
  "ferovinum.app.ledgercorrection.LedgerCorrectionDetail" : LedgerCorrectionDetail_AST
};
